<template>
  <article class="overflow-hidden rounded-[28px] border border-gray-100 bg-white shadow-lg transition hover:shadow-xl">
    <div class="grid gap-0 lg:grid-cols-5">
      <!-- Image -->
      <div class="relative h-56 lg:col-span-2 lg:h-full">
        <img :src="image" :alt="title" class="h-full w-full object-cover" />
        <div class="absolute top-4 left-4 rounded-full bg-white/90 backdrop-blur-sm px-3 py-1 text-xs font-semibold uppercase tracking-[0.2em] text-gray-500">
          {{ category }}
        </div>
        <div v-if="flightIncluded" class="absolute bottom-4 left-4 inline-flex items-center gap-1.5 rounded-full bg-amber-500 px-3 py-1 text-xs font-semibold text-white">
          <svg class="h-3.5 w-3.5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.874L5.999 12zm0 0h7.5" />
          </svg>
          Flights Included
        </div>
      </div>

      <!-- Content -->
      <div class="p-6 lg:col-span-3 lg:p-8">
        <div class="flex flex-col gap-1 sm:flex-row sm:items-baseline sm:justify-between">
          <h3 class="text-2xl font-bold text-gray-900">{{ title }}</h3>
          <span class="text-sm font-medium text-gray-500">{{ nights }}</span>
        </div>
        <p class="mt-1 text-sm text-gray-600">{{ cities }}</p>

        <ul class="mt-3 space-y-1">
          <li v-for="(hotel, idx) in hotels" :key="idx" class="flex items-start gap-2 text-sm text-gray-600">
            <span class="mt-2 h-1 w-4 flex-shrink-0 rounded-full bg-amber-400" />
            <span>{{ hotel }}</span>
          </li>
        </ul>

        <!-- Available Months -->
        <div class="mt-4">
          <p class="text-xs font-semibold uppercase tracking-wide text-gray-400 mb-1.5">Available Departures</p>
          <div class="flex flex-wrap gap-1.5">
            <span
              v-for="month in months"
              :key="month"
              class="rounded-full bg-amber-50 px-2.5 py-1 text-xs font-medium text-amber-700"
            >
              {{ month }}
            </span>
          </div>
        </div>

        <!-- Pricing Table -->
        <div class="mt-5 overflow-hidden rounded-2xl border border-gray-100">
          <table class="w-full text-sm">
            <thead>
              <tr class="bg-gray-50 text-left text-xs uppercase tracking-wide text-gray-500">
                <th class="px-4 py-2 font-semibold">Room Type</th>
                <th class="px-4 py-2 font-semibold text-right">Price / Person</th>
                <th class="px-4 py-2"></th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-100">
              <tr v-for="tier in pricing" :key="tier.type">
                <td class="px-4 py-2.5 text-gray-700">{{ tier.type }}</td>
                <td class="px-4 py-2.5 text-right font-semibold text-gray-900">{{ formatPrice(tier.price) }}</td>
                <td class="px-4 py-2.5 text-right">
                  <a
                    :href="whatsappUrl(tier)"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="inline-block rounded-full bg-amber-500 px-3 py-1 text-xs font-semibold text-white transition hover:bg-amber-600"
                  >
                    Book
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="mt-2 text-xs text-gray-400">Prices are per person in PKR, based on double/twin occupancy per room type shown, and subject to availability.</p>
      </div>
    </div>
  </article>
</template>

<script>
import { formatPrice } from '../services/currencyStore'

export default {
  name: 'PackagePricingCard',
  props: {
    title: { type: String, required: true },
    category: { type: String, default: 'Umrah' },
    image: { type: String, required: true },
    nights: { type: String, required: true },
    cities: { type: String, required: true },
    hotels: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    flightIncluded: { type: Boolean, default: true },
    pricing: { type: Array, default: () => [] },
    whatsappNumber: { type: String, required: true }
  },
  methods: {
    formatPrice,
    whatsappUrl(tier) {
      const message = `I want to book the *${this.title}* package — ${tier.type} (${this.formatPrice(tier.price)}/person).`
      const encodedMessage = encodeURIComponent(message)
      const cleanNumber = this.whatsappNumber.replace(/[^0-9]/g, '')
      return `https://wa.me/${cleanNumber}?text=${encodedMessage}`
    }
  }
}
</script>
